import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Alert } from './ui/alert';
import { Badge } from './ui/badge';


import { useAuth } from "../Services/AuthContext";
import { LogIn, Eye, EyeOff, Sun, Moon, User, Crown, Star, Shield } from 'lucide-react';
// import worldsviewLogoDark from '/Logo.png';
// import worldsviewLogoLight from '/Logo.png';

interface LoginProps {
  isDarkMode: boolean;
}

export function Login({ isDarkMode }: LoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {}, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // setIsLoading(true);

    await login();
    console.log(`Login complete`)
    navigate("/dashboard");

    // const res = await fetch("/login", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ user: { email, password } }),
    // });

    // if (res.ok) {
    //   const token = res.headers.get("Authorization");
    //   const user = await res.json();
    //   login(user.user, token);
    //   navigate("/dashboard");
    // } else {
    //   setError('Invalid email or password. Please try again.');
    // }

    // setIsLoading(false);
  };

  return (
    <div className="min-h-screen glass-background-optimized flex items-center justify-center p-6">
      <div className="w-full max-w-2xl space-y-6">
        {/* Logo and Header */}
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <img 
              src={isDarkMode ? "/Logo.png" : "/Logo.png"} 
              alt="Worldsview" 
              className="h-12 w-auto"
            />
          </div>
          <h1 className="mb-2">Partner Portal</h1>
          <p className="text-muted-foreground">Sign in to access your partner resources</p>
        </div>

        <div className="max-w-md mx-auto space-y-6">
          {/* Login Form */}
          <Card className="glass-card">
            <CardHeader>
              <CardTitle className="flex items-center justify-center text-base">
                <LogIn className="w-4 h-4 mr-2" />
                Sign In
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <Alert className="border-destructive text-destructive text-sm">
                    {error}
                  </Alert>
                )}
                <Button 
                  type="submit" 
                  className="w-full bg-worldsview-blue hover:bg-worldsview-blue/90 text-white text-sm"
                  disabled={isLoading}
                >
                  {isLoading ? 'Signing In...' : 'Sign In'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>

        {/* Help */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            Need help accessing your account? Contact your system administrator or{' '}
            <a 
              href={`mailto:help@worldsviewsupport.on.spiceworks.com?subject=WF Partner portal query ${new Date().toLocaleDateString('en-GB')}`}
              className="text-worldsview-blue hover:underline"
            >
              Worldsview Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
